// istanbul ignore file
import styled from 'styled-components';
import { SingleTrigger } from '../../components/Trigger/Trigger';

export const StyledPlaceholder = styled(SingleTrigger)`
  opacity: 0;
`;

export const WorkspaceDropdownTriggerWrapper = styled.div`
  margin: 0 ${(props) => props.theme.spacing.xs};
`;
